export default "__VITE_ASSET__Bbm8Xo78__"